import { render, staticRenderFns } from "./Amplify.vue?vue&type=template&id=20c8fc6b&"
import script from "./Amplify.vue?vue&type=script&lang=js&"
export * from "./Amplify.vue?vue&type=script&lang=js&"
import style0 from "@aws-amplify/ui/dist/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./Amplify.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Amplify.vue"
export default component.exports